const apiUrl = process.env.REACT_APP_API_URL;

export const GetParticipants = async (
    page: string,
    inici: string,
    fin: string
): Promise<any[]> => {
    try {
        const response = await fetch(
            `${apiUrl}:8072/participants?inici=${inici}&fin=${fin}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'pantalla': page
                }
            }
        );
        if (!response.ok) {
            console.error('GetParticipants error:', response.status);
            return [];
        }
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('GetParticipants fetch error:', error);
        return [];
    }
};
